import { z } from 'zod';
import { ROLES } from '../dominio.js';
import { correo, uuid } from './comunes.js';
/**
 * Administración de cuentas.
 *
 * Dos decisiones que condicionan todo lo demás:
 *
 * 1. **El administrador nunca escribe la contraseña de otra persona.** Al crear
 *    una cuenta o restablecerla, el sistema genera una temporal que se muestra
 *    una sola vez; el titular la cambia al entrar. Si el administrador la
 *    eligiera, la conocería, y el historial dejaría de probar quién hizo cada
 *    cosa.
 * 2. **Las cuentas no se borran, se desactivan.** Cada usuario está referenciado
 *    por los documentos que creó, sus firmas y el historial de estados. Borrarlo
 *    rompería la trazabilidad, que es la razón de ser del sistema.
 */
const nombre = (etiqueta) => z.string().trim().min(2, `${etiqueta} es obligatorio`).max(120);
/** DNI peruano: 8 dígitos. Opcional — no todo usuario lo tiene registrado. */
const dni = z
    .string()
    .trim()
    .regex(/^\d{8}$/, 'El DNI debe tener 8 dígitos')
    .nullish();
export const usuario = z.object({
    id: uuid,
    nombres: z.string(),
    apellidos: z.string(),
    correo: z.string(),
    cargo: z.string().nullable(),
    dni: z.string().nullable(),
    rol: z.enum(ROLES),
    rolNombre: z.string(),
    activo: z.boolean(),
    /** true mientras no haya estrenado su contraseña definitiva. */
    debeCambiarPassword: z.boolean(),
    ultimoAcceso: z.string().nullable(),
});
/**
 * Los campos vacíos del formulario llegan como '' y deben guardarse como
 * ausentes: '' violaría el formato del DNI y ocuparía el UNIQUE, impidiendo
 * que un segundo usuario se quede también sin DNI.
 */
const vacioEsNulo = (v) => (typeof v === 'string' && v.trim() === '' ? null : v);
export const usuarioEntrada = z.object({
    nombres: nombre('El nombre'),
    apellidos: nombre('El apellido'),
    correo,
    cargo: z.preprocess(vacioEsNulo, z.string().trim().max(120).nullish()),
    dni: z.preprocess(vacioEsNulo, dni),
    rol: z.enum(ROLES),
});
/**
 * `.partial()` conserva los `.default()` de Zod, así que una edición de solo el
 * cargo llegaría inyectando `activo` sin que nadie lo pidiera. Por eso ningún
 * campo de arriba lleva default y `activo` se declara aparte, opcional.
 */
export const usuarioEdicion = usuarioEntrada
    .partial()
    .extend({ activo: z.boolean().optional() });
/** La contraseña temporal se devuelve UNA vez; después ya no es recuperable. */
export const usuarioCreado = z.object({
    usuario,
    passwordTemporal: z.string(),
});
export const idUsuario = z.object({ id: uuid });
//# sourceMappingURL=usuario.js.map